import { useEffect, useState } from 'react';
import Modal from 'ui/Modal';

export default function AlertListener () {
  const [alert, setAlert] = useState();

  useEffect(() => {
    const handler = (event) => {
      const { type, message } = event.detail;
      setAlert({ type, message });
    }

    window.addEventListener('alert', handler);
    return () => window.removeEventListener('alert', handler);
  }, []);

  if (!alert) return null;

  return (
    <Modal
      show="true"
      close={() => setAlert(null)}
      className="alert-modal"
    >
      {alert.message}
    </Modal>
  )
};
